import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { HeaderComponent } from 'retail/app/core/components/header/header.component';
import { HomepageComponent } from 'retail/app/core/components/homepage/homepage.component';
import { MenuComponent } from 'retail/app/core/components/menu/menu.component';
import { SearchComponent } from 'retail/app/core/components/search/search.component';
import { AuthGuard } from 'retail/app/core/providers/auth.guard';
import { AuthService } from 'retail/app/core/providers/auth.service';
import { HomepageService } from 'retail/app/core/providers/homepage.service';
import { SharedUiModule } from 'shared-ui/shared-ui.module';

@NgModule({
  declarations: [HeaderComponent, HomepageComponent, MenuComponent, SearchComponent],
  exports: [HeaderComponent, HomepageComponent, MenuComponent],
  imports: [CommonModule, LazyLoadImageModule, ReactiveFormsModule, RouterModule, SharedUiModule, NgOptimizedImage],
  providers: [AuthGuard, AuthService, HomepageService],
})
export class RetailCoreModule {}
